
import { defineComponent, provide, ref } from 'vue';
import Parent from './components/Parent.vue';
export default defineComponent({
    name: 'App',
    components: {
        Parent,
    },
    setup() {
        const color = ref('red');
        provide('color', color);
        return {
            color,
        }
    }
});
